import { render, staticRenderFns } from "./AddAuctionPage.vue?vue&type=template&id=2aff9de5&scoped=true&"
import script from "./AddAuctionPage.vue?vue&type=script&lang=js&"
export * from "./AddAuctionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff9de5",
  null
  
)

export default component.exports